module.exports = __webpack_public_path__ + "img/hook-unity.e99cab49.png";